<template>
    <b-card>
        <h4 class="card-title">Revised Invoices Waiting For Submission</h4>
        <small class="text-muted">You've revised visits that were previously invoiced.  Review and re-submit the related invoices.</small>
      <loading-card :message="this.loading_message" v-if="loading" />
        <b-table hover
                 sort-by="created_at"
                 :items="items"
                 v-show="!loading"
                 :fields="fields">
            <template v-slot:cell(actions)="data">
                <a :href="`/invoice-history/${data.item.id}/print`" class="btn btn-secondary">
                    View PDF
                </a>
                <b-btn variant="success" @click="submitInvoice(data.item.id)">Re-submit to LTC</b-btn>
            </template>
        </b-table>
    </b-card>
</template>

<script>
    import FormatsDates from '../../mixins/FormatsDates';
    import FormatsNumbers from '../../mixins/FormatsNumbers';

    export default {
        props: ['client', 'invoices'],

        mixins: [FormatsDates, FormatsNumbers],

        data() {
            return {
                loading: false,
                loading_message : 'Processing...',
                items: this.invoices,
                fields: [
                    {
                        key: 'name',
                        label: 'Invoice #',
                    },
                    {
                        key: 'week',
                        label: 'Week Ending',
                        formatter: this.weekEnding,
                    },
                    {
                        key: 'submitted_at',
                        label: 'Date Submitted',
                        formatter: (val) => val ? this.formatDateFromUTC(val) : 'Pending',
                    },
                    {
                        key: 'hours',
                        formatter: (val) => this.numberFormat(val),
                    },
                    {
                        key: 'amount',
                        formatter: (val) => this.moneyFormat(val),
                    },
                    {
                        key: 'actions',
                        class: 'hidden-print'
                    }
                ]
            }
        },
        methods: {
            async submitInvoice(id) {
                let form = new Form({});
                this.loading = true;
                try {
                  const response = await form.post(`/invoice-history/${id}/submit`)
                  if (response.status > 199 && response.status < 299) {
                    this.items = this.items.filter(invoice => {
                      return invoice.id != id;
                    });
                  }
                } finally {
                  this.loading = false;
                }
            },

            weekEnding(week) {
                if (week) {
                    if ('end' in week) {
                        return this.formatDate(week.end);
                    }
                }
                return 'N/A';
            },
        }
    }
</script>

<style scoped>

</style>
